'use strict'

require '../../../../../core/frontend/groupon_modules/ariaKeyNavigation'
require '../../../../../modules/gig_body/header/frontend/views/pn_primarynav'

module.exports = class PNHeaderV2 extends Groupon.AriaMenuNavigation
  constructor: (@$el) ->
    @$primaryNav = @$el.find('.primary-nav')
    @initialize()

  initialize: ->
    unless $('#ls-lite-header').length
      new Groupon.LS.Header.PNPrimaryNav @$primaryNav

  bind: ->

    if ($userName = $('.user-name')).length
      $userMenu = $('#ls-my-stuff')

      # LS-1179 make flyout accessible for touch
      if Groupon.LS.hasTouch

        $userName.on 'lstouch', (e) ->
          return if e.lsDoubleTouch

          e.preventDefault()
          e.stopImmediatePropagation()
          if $userMenu.is(':visible')
            $userMenu.hide()
          else
            $userMenu.show()
          $userMenu.attr( 'aria-hidden', $userMenu.attr('aria-hidden') isnt 'true')
          # close other header menus
          $('html').trigger 'tap'
          if $userMenu.is(':visible')
            # unbind event first, then register closing event once
            $('html').off('tap.username').one 'tap.username', (event) ->
              if $(event.target).closest('.user-name, .my-stuff').length == 0
                $userMenu.hide().attr('aria-hidden', 'true')
      else
        @initMenuNavigation($userName, $userMenu, $userMenu.find('a'))
